var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Most Starred Github Repositories in the last 30 days ")]),_c('hr'),_c('RepoList',{attrs:{"repos":_vm.repos}}),_c('Trigger',{on:{"triggerIntersected":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }